<template>
  <div class="unlabelled">
    <v-overlay
      :value="conceptsLoading || kitchensLoading || platformsLoading || unlabelledloading || combosLoading || menuItemsLoading"
    >
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-tabs
      v-model="tab"
      color="red accent-2"
      background-color="grey lighten-4"
      :centered="false"
      height="75px"
      show-arrows
    >
      <v-tabs-slider></v-tabs-slider>
      <v-tab
        v-for="[key, value] of Object.entries(sortedTabs)"
        :key="key"
        :href="`#tab-${key}`"
        class="pt-2"
      >
        <v-avatar size="50px" tile>
          <v-img :src="getElementByUuid(key, concepts).logo" contain class />
        </v-avatar>
        <span class="ml-2">{{ getElementByUuid(key, concepts).label }} ({{value.length}})</span>
      </v-tab>
      <v-tabs-items v-model="tab">
        <v-tab-item
          v-for="[key, value] of Object.entries(sortedTabs)"
          :key="key"
          :value="`tab-${key}`"
        >
          <UnlabelledTab
            :unlabelledList="value"
            :concepts="concepts"
            :kitchens="kitchens"
            :platforms="platforms"
            :combos="combos"
            :menuItems="menuItems"
            :labelizationStatuses="labelizationStatuses"
            v-on:selectItem="selectItem"
            v-on:deleteUnlabelled="delUnlabelled"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import _ from "lodash";
import UnlabelledTab from "@/components/Unlabelled/UnlabelledTab";

export default {
  components: { UnlabelledTab },
  data: () => {
    return {
      tab: "",
    };
  },
  computed: {
    ...mapState({
      unlabelled: (state) => state.normalizer.all,
      unlabelledloading: (state) => state.normalizer.fetchAll.pending,
      labelizeLoading: (state) => state.normalizer.labelize.pending,
      deleteLoading: (state) => state.normalizer.deleteUnlabelled.pending,
      labelizationStatuses: (state) => state.normalizer.labelizationStatuses,
      concepts: (state) => state.restaurant.concepts,
      conceptsLoading: (state) => state.restaurant.fetchAllConcepts.pending,
      kitchens: (state) => state.restaurant.kitchens,
      kitchensLoading: (state) => state.restaurant.fetchAllKitchens.pending,
      platforms: (state) => state.restaurant.platforms,
      platformsLoading: (state) => state.restaurant.fetchAllPlatforms.pending,
      combos: (state) => state.items.combos,
      combosLoading: (state) => state.items.fetchAllCombos.pending,
      menuItems: (state) => state.items.menuItems,
      menuItemsLoading: (state) => state.items.fetchAllMenuItems.pending,
    }),
    tabs() {
      let tabs = _.groupBy(this.unlabelled, (order) => {
        return order.last_seen.concept_uuid;
      });
      return Object.keys(tabs).sort();
    },
    sortedTabs() {
      return _.groupBy(this.unlabelled, (order) => {
        return order.last_seen.concept_uuid;
      });
    },
  },
  methods: {
    ...mapActions({
      setError: "setError",
    }),
    ...mapActions("normalizer", {
      fetchAll: "fetchAll",
      labelize: "labelize",
      deleteUnlabelled: "deleteUnlabelled",
    }),
    ...mapActions("restaurant", {
      fetchAllConcepts: "fetchAllConcepts",
      fetchAllKitchens: "fetchAllKitchens",
      fetchAllPlatforms: "fetchAllPlatforms",
    }),
    ...mapActions("items", {
      fetchAllCombos: "fetchAllCombos",
      fetchAllMenuItems: "fetchAllMenuItems",
    }),
    getElementByUuid(uuid, list) {
      return list.find((obj) => obj.uuid === uuid);
    },
    selectItem(unlabelledUuid, itemUuid, itemType) {
      this.labelize({
        unlabelledUuid: unlabelledUuid,
        itemUuid: itemUuid,
        itemType: itemType,
      }).catch((error) => {
        this.setError(error);
      });
    },
    delUnlabelled(unlabelledUuid) {
      this.deleteUnlabelled({ uuid: unlabelledUuid }).catch((error) => {
        this.setError(error);
      });
    },
  },
  created() {
    this.fetchAll().catch((error) => {
      this.setError(error);
    });
    this.fetchAllConcepts().catch((error) => {
      this.setError(error);
    });
    this.fetchAllKitchens().catch((error) => {
      this.setError(error);
    });
    this.fetchAllPlatforms().catch((error) => {
      this.setError(error);
    });
    this.fetchAllCombos().catch((error) => {
      this.setError(error);
    });
    this.fetchAllMenuItems().catch((error) => {
      this.setError(error);
    });
  },
};
</script>
